import { useMemo, useState } from "react";
import HumanResourceLayout from "../../../components/layouts/HumanResourceLayout";
import { Helmet } from "react-helmet-async";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { leaveManagement } from "../../../components/custom_tab/tabColumns";
import LeaveRequestsView from "./views/LeaveRequestsView";
import LeavePackagesView from "./views/LeavePackagesView";
import { useSearchParams } from "react-router-dom";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import useUserStore from "../../../state-management/useUserStore";

const LeaveManagement = () => {
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			default: 
				return HumanResourceLayout;
		}
	}, [userType])
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "leaveRequestsView"
	);

	return (
		<LAYOUT>
			<Helmet>
				<title>Leave Management |{userType === "HR" ? " HR " : " Company "}Flow </title>
			</Helmet>
			<h1 className="font-bold text-xl text-charcoal mb-8">Leave Management</h1>
			<CustomTab
				view={view}
				setView={setView}
				tabColumns={leaveManagement}
			>
				<div className="mt-6">
					{view === "leaveRequestsView" && <LeaveRequestsView />}
					{view === "leavePackagesView" && <LeavePackagesView />}
				</div>
			</CustomTab>
		</LAYOUT>
	);
};

export default LeaveManagement;
